<template>
  <component :is="componentName" />
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Dashboard',
  components: {
    'patient-dashboard': () => import(/* webpackChunkName: "patient-dashboard" */ './components/PatientDashboard'),
    'provider-dashboard': () => import(/* webpackChunkName: "provider-dashboard" */ './components/ProviderDashboard'),
    'super-admin-dashboard': () => import(/* webpackChunkName: "super-admin-dashboard" */ './components/SuperAdminDashboard'),
    'clinic-admin-dashboard': () => import(/* webpackChunkName: "clinic-admin-dashboard" */ './components/ClinicAdminDashboard'),
  },
  computed: {
    ...mapState('loggedAccount', ['account']),
    componentName() {
      let componentName = '';

      if (this.account && this.account.role === 'PROVIDER') componentName = 'provider-dashboard';
      else if (this.account && this.account.role === 'PATIENT') componentName = 'patient-dashboard';
      else if (this.account && this.account.role === 'SUPER_ADMIN') componentName = 'super-admin-dashboard';
      else if (this.account && this.account.role === 'CLINIC_ADMIN') componentName = 'clinic-admin-dashboard';

      return componentName;
    },
  },
};
</script>
